import { PORTLET_FETCH_SUCCESS } from 'js/components/system/Portlet';
import { EXPAND_ITEM, TOGGLE_LOADING, SET_ERROR } from './actions';

export const initialState = {
    expandedItem: -1,
    isLoading: true,
    error: ''
};

export default (reducerSuffix) => (state = initialState, action) => {
    switch (action.type) {
        case PORTLET_FETCH_SUCCESS:
        case PORTLET_FETCH_SUCCESS + reducerSuffix: {
            const { response: preWagerBalances } = action.payload;

            return {
                ...state,
                preWagerBalances
            };
        }

        case EXPAND_ITEM:
        case EXPAND_ITEM + reducerSuffix: {
            const { payload: index } = action;
            const { expandedItem } = state;

            return {
                ...state,
                expandedItem: expandedItem === index ? -1 : index
            };
        }

        case TOGGLE_LOADING:
        case TOGGLE_LOADING + reducerSuffix: {
            return { ...initialState, isLoading: action.payload };
        }

        case SET_ERROR:
        case SET_ERROR + reducerSuffix: {
            const { error } = action.payload;

            return { ...initialState, error };
        }

        default:
            return state;
    }
};
